import { render, staticRenderFns } from "./memberAssets.vue?vue&type=template&id=f185175e&scoped=true&"
import script from "./memberAssets.vue?vue&type=script&lang=js&"
export * from "./memberAssets.vue?vue&type=script&lang=js&"
import style0 from "./memberAssets.vue?vue&type=style&index=0&id=f185175e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f185175e",
  null
  
)

export default component.exports